export const myHrTranslationsEn = {
  MY_HR_RESET_2FA_CONFIRM_INFO:
    "Are you sure you want to reset authentication?",
  MY_HR_RESET_2FA_CONFIRM_RESET: "Confirm reset",
  MY_HR_VERIFICATION_CODE_MAX_ATTEMPTS_REACHED:
    "You have reached the maximum number of attempts for entering the verification code",
  MY_HR_EMAIL_VERIFICATION_CODE_SENT:
    "A verification code has been sent to your email address. Please check your inbox.",
  MY_HR_TWO_FACTOR_AUTHENTICATION_RESET_SUCCESS:
    "Two-factor authentication has been successfully reset.",
  MY_HR_TWO_FACTOR_AUTHENTICATION_RESET_FAILED:
    "Something went wrong while trying to reset two-factor authentication.",
  MY_HR_VERIFICATION_CODE_EXPIRED:
    "This verification code has already expired!",
  MY_HR_INVALID_VERIFICATION_CODE: "Invalid verification code!",
  MY_HR_2FA_CHOOSE_OPTION: "You can choose between two options:",
  MY_HR_EMAIL_BASED_AUTHENTICATION: "Email-based authentication",
  MY_HR_EMAIL_AUTHENTICATION_DESCRIPTION:
    "After entering your password, the OrgwareConnect system will send you an email containing a one-time code. You can enter this code into the designated field within a limited time period.",
  MY_HR_APP_BASED_AUTHENTICATION: "App-based authentication",
  MY_HR_APP_AUTHENTICATION_DESCRIPTION:
    "After entering your password, the second code will be available in your authenticator app. This code changes continuously. There are several apps available, with one of the most popular being Google Authenticator, which is available on both Android and iOS (others include 1Password, Authy, Apple Passwords, etc.). To access the code, you need to set up the app using a QR code or another method.",
  MY_HR_2FA_DESCRIPTION:
    "Two-factor authentication (2FA) is a security method that requires users to verify their identity in addition to entering their login email and password. This significantly reduces the risk of unauthorized access to your account and misuse of your data.",
  MY_HR_2FA_MANDATORY_FROM_DATE:
    "Starting from {{date}}, two-factor authentication will be required to log in to your OrgwareConnect account.",
  MY_HR_USER_LOCKED: "User locked",
  MY_HR_INACTIVE: "Inactive",
  MY_HR_USER_NOT_REGISTERED_2FA:
    "The user has not yet registered two-factor authentication on their account.",
  MY_HR_AUTH_CODE_FAILED_THREE_TIMES:
    "The user entered the authentication code incorrectly three times in a row.",
  MY_HR_TWO_FACTOR_AUTHENTICATION_ACTIVE:
    "The user has registered two-factor authentication on their account.",
  MY_HR_ACCOUNT_LOCKED_AFTER_FAILED_ATTEMPTS:
    "You have attempted to log in unsuccessfully three times and have been locked out of the system for security reasons. Please contact your local system administrator.",
  MY_HR_REGISTRATION_DEADLINE: "Registration deadline",
  MY_HR_ENABLED_2FA:
    "Apply authentication one-time code using email or an authenticator app.",
  MY_HR_RETRY_QR_CODE_SCAN: "Try scanning the QR code again",
  MY_HR_ENTER_MANUAL_CODE_INTO_AUTH_APP:
    "If you can't scan the QR code with your camera, enter the following code into your authenticator app to link it with your OrgwareConnect account:",
  MY_HR_CANNOT_SCAN_QR_CODE: "Can't scan the QR code?",
  MY_HR_SCAN_QR_WITH_AUTHENTICATOR_APP:
    "Use your authenticator app to scan the QR code. If you don't have an authenticator app on your device, you will need to install one.",
  MY_HR_ENTER_VERIFICATION_CODE: "Enter the verification code.",
  MY_HR_USE_COMPATIBLE_AUTHENTICATOR_APP:
    "Use a compatible authenticator app (e.g., Google Authenticator, Authy, Apple Passwords, etc.). We will generate a QR code that you can scan.",
  MY_HR_LINK_AUTHENTICATOR_APP:
    "Link an authenticator app to your OrgwareConnect account",
  MY_HR_PROTECT_ACCOUNT_TWO_STEPS: "Protect your account in just two steps",
  MY_HR_SECONDS_REMAINING: "{{countdown}} seconds remaining",
  MY_HR_SEND_AUTHENTICATION_EMAIL: "Send authentication email",
  MY_HR_EMAIL_CODE_REQUEST:
    "To verify your identity, please enter the code sent via email.",
  MY_HR_VERIFICATION: "Verification",
  MY_HR_ENTER_AUTHENTICATION_CODE: "Enter the authentication code",
  MY_HR_2FA_APP_LOGIN_INFO:
    "To verify your identity, please enter the code generated by your two-factor authentication app.",
  MY_HR_2FA_AUTHENTICATION: "Two-factor authentication",
  MY_HR_2FA_DATE_INFO:
    "Two-factor authentication will be mandatory from {{date}}.",
  MY_HR_NOT_SET_UP_2FA: "You don't have two-factor authentication set up yet.",
  MY_HR_TWO_FACTOR_AUTHENTICATION_TYPE: "Authentication type",
  MY_HR_RESET_TWO_FACTOR_AUTHENTICATION_INFO:
    "You can initiate a change to your current secret key, but in the case of an authentication application, you will need to re-register the first time you log in.",
  MY_HR_RESET_TWO_FACTOR_AUTHENTICATION: "Reset two-factor authentication",
  MY_HR_TWO_FACTOR_AUTHENTICATION: "Two-factor authentication",
  MY_HR_MYINFO_PAGE_TITLE: "My general information",
  MY_HR_USER_DATA_EDIT_PAGE_PAGE_TITLE: "Processing data change requests",
  MY_HR_ADMIN_USERS_PAGE_TITLE: "Manage users",
  MY_OTHER_USER_PAGE_TITLE: "User account management",
  MY_HR_ADD_ALL_PERMISSIONS_DIALOG_INFO:
    "If no filter condition is set, all employees will belong to the role.",
  MY_HR_ERROR_MESSAGE_NO_CONTRACT_FOUND: "No valid legal contract found!",
  MY_HR_POSITION: "Position",
  MY_HR_NOT_HAVE_ROLE: "This user did not have such a role.",
  MY_HR_ERROR_MESSAGE_INVALID_USERNAME: "Invalid username",
  MY_HR_ACCEPTABLE_DISTRICT_FORMAT: "Accepted format: 01, 12, etc.",
  MY_HR_PASSWORD_VISIBILITY_INFO:
    "In order to verify the entered password, we can use the eye icon to give the user the opportunity to see if they really typed what they wanted.",
  MY_HR_PASSWORD_VISIBILITY: "Password visibility",
  MY_HR_ADD_ROLE_ERROR: "Add role error",
  MY_HR_CONTRACT_NOT_PERMISSION_TO_LEAVE:
    "Leave cannot be established for this permission",
  MY_HR_CHANGE_REQUESTS: "Change requests",
  MY_HR_MY_CHANGE_REQUEST: "My change request",
  MY_HR_CHANGE_REQUEST_EMAIL: "Change request email address",
  MY_HR_NOT_VALID_PHONE_NUMBER: "Not valid phone number!",
  MY_HR_CHANGE_REQUEST_SETTINGS: "Change requests enabled",
  MY_HR_EDIT_SERVICE_ADDRESS: "Edit service address",
  MY_HR_EDIT_TEMPORARY_ADDRESS: "Edit temporary address",
  MY_HR_EDIT_PERMANENT_ADDRESS: "Edit permanent address",
  MY_HR_EDIT_EMAILS_OTHER: "Edit other email",
  MY_HR_EDIT_EMAILS_WORK: "Edit work email",
  MY_HR_EDIT_PHONES_PRIVATE: "Edit private phone",
  MY_HR_EDIT_PHONES_WORK_MOBILE: "Edit work mobile phone",
  MY_HR_EDIT_PHONES_WORK: "Edit work phone",
  MY_HR_ADD_GROUP_PASSWORD_NOT_ON_SSO:
    "This system uses single sign on login type. The automatic password generation is not enabled.",
  MY_HR_AUTOMATIC_PASSWORD_GENERATION: "Automatic password generation",
  MY_HR_AUTOMATIC_PASSWORD_GENERATION_INFO:
    "You can enable with this switch the automatic password generation",
  MY_HR_SEND_GROUP_PASSWORDS_DIALOG_TITLE: "Add group passwords confirmation",
  MY_HR_SEND_GROUP_PASSWORDS_DIALOG_TEXT:
    "Are you sure to add password to selected user(s)?",
  MY_HR_SEND_GROUP_PASSWORDS_TO_ALL_DIALOG_TEXT:
    "Are you sure to add password to all users?",
  MY_HR_SEND_GROUP_PASSWORDS_INFO:
    "Add passwords for existing OrgwareConnect users.",
  MY_HR_SEND_GROUP_PASSWORDS_SUCCEEDED: "Add passwords successfully run",
  MY_HR_PASSWORD_SENT: "password(s) added",
  MY_HR_PASSWORD_SWITCH_TEXT: "Replace existing passwords",
  MY_HR_SEND_PASSWORD_INFO_TEXT:
    "With the push button you could create a new initial password for all user selected with filter",
  MY_HR_ADD_GROUP_PASSWORD_TITLE: "Add group password",
  MY_HR_ROLE_REMOVED: "role removed",
  MY_HR_REMOVE_ROLE_SUCCEEDED: "Remove group role succeeded.",
  MY_HR_REQUEST_PERMIT: "Request permit",
  MY_HR_PERMIT_REQUESTED: "Request has sent!",
  MY_HR_IT_IS_ALREADY_GRANTED: "This request is already granted!",
  MY_HR_PERMIT_GRANTED:
    "Orgware Admin Login enabled for employees of Orgware Kft.",
  MY_HR_SYSTEM_USER_NAME: "System username",
  MY_HR_SYSTEM_USER_PASSWORD: "Service user password",
  MY_HR_DOMAIN_SUFFIX: "Domain suffix",
  MY_HR_CONTRACT_ALREADY_HAS_THIS_ROLE: "The contract already has this role.",
  MY_HR_ADD_GROUP_ROLE_DIALOG_TITLE: "Add group role confirmation",
  MY_HR_ADD_GROUP_ROLE_TO_ALL_DIALOG_TEXT:
    "Are you sure to add role to all users?",
  MY_HR_ADD_GROUP_ROLE_DIALOG_TEXT:
    "Are you sure to add role to selected user(s)?",
  MY_HR_REMOVE_GROUP_ROLE_DIALOG_TITLE: "Remove group role confirmation",
  MY_HR_REMOVE_GROUP_ROLE_TO_ALL_DIALOG_TEXT:
    "Are you sure to remove role to all users?",
  MY_HR_REMOVE_GROUP_ROLE_DIALOG_TEXT:
    "Are you sure to remove role to selected user(s)?",
  MY_HR_INACTIVATE_USERS_TO_ALL_DIALOG_TEXT:
    "Are you sure to inactivate all users?",
  MY_HR_INACTIVATE_USERS_DIALOG_TEXT:
    "Are you sure to inactivate selected user(s)?",
  MY_HR_INACTIVATE_USERS_SUCCESSFULLY: "Inactivate user(s) successfully",
  MY_HR_INACTIVATE_USERS_FAILED: "Inactivate failed",
  MY_HR_INACTIVATE_USERS_DIALOG_TITLE: "Inactivate groups confirmation",
  MY_HR_INACTIVATE: "Managing",
  MY_HR_INACTIVATE_BUTTON: "Inactivate",
  MY_HR_ADD_ROLE_SUCCEEDED: "Add role succeeded",
  MY_HR_ROLE_ADDED: "role added",
  MY_HR_ADD_MASS_ROLE: "Add new role",
  MY_HR_ADD_MASS_ROLE_INFO: "Add new role for existing OrgwareConnect users.",
  MY_HR_REMOVE_MASS_ROLE: "Remove role",
  MY_HR_REMOVE_MASS_ROLE_INFO:
    "Remove role from existing OrgwareConnect users.",
  MY_HR_ADD_PERMISSION: "Create permission",
  MY_HR_ADD_ROLE: "Add role",
  MY_HR_REMOVE_ROLE: "Remove role",
  MY_HR_ADDRESS: "Address",
  MY_HR_ALL_TAX_DEDUCTIONS: "All tax and contribution deductions",
  MY_HR_BIRTH_CARD_TITLE: "Birth data",
  MY_HR_BUTTON_SEND: "Send",
  MY_HR_CHANGE_TEMPORARY_PASSWORD_TAX_NUMBER_ERROR:
    "The given tax number cannot be found in the system.",
  MY_HR_CITY: "City",
  MY_HR_CODE_CARD_TITLE: "Codes data",
  MY_HR_CONFIRM_NEW_PASSWORD: "Confirm new password",
  MY_HR_CONTACTS: "Contacts",
  MY_HR_CONTRACT_TYPE: "Contract type",
  MY_HR_GET_CONTRACT: "Contract",
  MY_HR_COUNTRY_OF_BIRTH: "Country of birth",
  MY_HR_COUNTRY: "Country",
  MY_HR_CREATE_USER: "Create new user",
  MY_HR_CURRENT_PASSWORD: "Current password",
  MY_HR_DATE_OF_BIRTH: "Date Of birth",
  MY_HR_DEDUCTIONS: "Deductions",
  MY_HR_EMAIL_OTHER: "Other email",
  MY_HR_EMAIL_WORK: "Work email",
  MY_HR_EMAIL: "Email",
  MY_HR_EMPLOYMENT_TYPE: "Employment type",
  MY_HR_ERROR_MESSAGE_INVALID_EMPLOYEE_CODE: "Invalid employee code!",
  MY_HR_ERROR_MESSAGE_NO_USER_FOUND: "No user found!",
  MY_HR_ERROR_MESSAGE_PASSWORD_IS_REQUIRED: "Password field is required!",
  MY_HR_ERROR_MESSAGE_TWO_PASSWORD_IS_DIFFERENT:
    "The two password is different!",
  MY_HR_ERROR_MESSAGE_USERNAME_IS_REQUIRED: "Username field is required!",
  MY_HR_ERROR_MESSAGE_WRONG_EMAIL_FORMAT: "Wrong email format!",
  MY_HR_ERROR_MESSAGE_WRONG_PASSWORD: "Wrong password!",
  MY_HR_ERROR_MESSAGE_WRONG_USERNAME_OR_PASSWORD: "Wrong username or password!",
  MY_HR_ERROR_MESSAGE_ACCOUNT_HAS_EXPIRED: "Your account has expired!",
  MY_HR_FIRST_NAME: "First name",
  MY_HR_GENDER: "Gender",
  MY_HR_GROSS_WAGE: "Gross monthly allowance",
  MY_HR_IDENTITY_CARD_NUMBER: "Identity card number",
  MY_HR_INFO_TEXT_NOT_STRONG_PASSWORD:
    "The password must be at least 8 chars long, and must contains letters and numbers.",
  MY_HR_INFO_TEXT_DIRECTORY:
    "The system uses Directory authentication, so the authentication is not an OrgwareConnect task.",
  MY_HR_INFO_TEXT_STRONG_PASSWORD:
    "The password must be at least 8 chars long, and must contains the following elements: lowercase letter, uppercase letter, number, special symbol (_#$). The password must be different to last five passwords.",
  MY_HR_JOB_CLASS: "Job class",
  MY_HR_LAST_LOGIN: "Last login",
  MY_HR_LAST_NAME: "Last name",
  MY_HR_GET_LAST_PASSWORD_CHANGE: "Last password change",
  MY_HR_LINK_BACK_TO_LOGIN: "Go back to login",
  MY_HR_LINK_FORGOT_PASSWORD: "Forgot password?",
  MY_HR_LOGIN: "Login",
  MY_HR_LOGOUT: "Logout",
  MY_HR_MARITAL_STATUS: "Marital status",
  MY_HR_MIDDLE_NAME: "Middle name",
  MY_HR_MOTHERS_NAME: "Mothers name",
  MY_HR_MY_PROFILE: "My profile",
  MY_HR_NAME_SUFFIX: "Forename",
  MY_HR_NATIONALITY: "Nationality",
  MY_HR_NET_WAGE: "Net salary",
  MY_HR_NEW_PASSWORD: "New password",
  MY_HR_NEW_USER: "New user",
  MY_HR_NO_PAYROLL_DATA: "There is no actual payroll data in this month.",
  MY_HR_ORGWARE_COMPANY_NAME: "Orgware Ltd.",
  MY_HR_OTHER_DEDUCTIONS: "Other deductions and allowances",
  MY_HR_PASSWORD: "Password",
  MY_HR_PAYROLL: "Payroll",
  MY_HR_PAYROLL_MENU_INFO: "Displaying payroll menu",
  MY_HR_PERMANENT_ADDRESS: "Permanent address",
  MY_HR_PERMISSION: "Permission",
  MY_HR_PERSONAL_DATA: "Personal data",
  MY_HR_PHONE_PRIVATE: "Private telephone",
  MY_HR_PHONE_WORK: "Work telephone",
  MY_HR_PHONE_WORKMOBILE: "Work mobile",
  MY_HR_PLACE_OF_BIRTH: "Place of birth",
  MY_HR_PREFIX_NAME: "Prefix name",
  MY_HR_PRESENT: "present",
  MY_HR_RECOVER_YOUR_PASSWORD: "Recover your password",
  MY_HR_RESTORE: "Restore",
  MY_HR_ROLE_USER: "User",
  MY_HR_ROLE_ADMIN: "Administrator",
  MY_HR_ROLE_EXAMINER: "Examiner",
  MY_HR_ROLE_VIEWER: "Viewer",
  MY_HR_ROLE_ASSIGNER: "Assigner",
  MY_HR_ROLE_UPLOADER: "Uploader",
  MY_HR_ROLE_EDITOR: "Editor",
  MY_HR_ROLES: "Roles",
  MY_HR_SELECT_EMPLOYEE: "Select employee",
  MY_HR_SEND_NEW_TEMPORARY_PASSWORD: "Send a new temporary password",
  MY_HR_SEND_TEMPORARY_PASSWORD_TEXT:
    "You can initiate changing the current user's password with sending a new, temporary one. The user must change this password on his/her first login.",
  MY_HR_SERVICE_ADDRESS: "Service address",
  MY_HR_SHIFT_TYPE: "Shift type",
  MY_HR_SIGN_IN: "Login",
  MY_HR_SELECTED_COMPANY: "Company name displayed on login page",
  MY_HR_SELECT_COMPANY: "Select company",
  MY_HR_SOCIAL_SECURITY_NUMBER: "Social security number",
  MY_HR_SYSTEM_SETTINGS: "System settings",
  MY_HR_SYSTEM: "System",
  MY_HR_TAX_NUMBER: "Tax number",
  MY_HR_TELEPHONE: "Telephone",
  MY_HR_TEMPORARY_ADDRESS: "Temporary address",
  MY_HR_TEMPORARY_PASSWORD_EMAIL_SENT: "The temporary password email sent",
  MY_HR_TEXT_COPYRIGHT: "All rights reserved!",
  MY_HR_TEXT_EMAIL_SENT:
    "Help is on the way. You can use a temporary password to create a new password.",
  MY_HR_TEXT_FORGOT_PASSWORD_IS_NOT_AVAILABLE:
    "The system's password recovery process is not available on single sign on sytems. Please contact the system administrator.",
  MY_HR_TEXT_PUBLIC_LAYOUT: "HR and Payroll seamlessly!",
  MY_HR_TEXT_SEND_EMAIL_DESCRIPTION:
    "Send us your email address and we will send you a temporary password to help you create a new password.",
  MY_HR_TEXT_UNLOCK:
    "Due to inactivity, your session is locked. Enter your password to continue.",
  MY_HR_TITLE_EMAIL_SENT: "We have sent the temporary pasword",
  MY_HR_TITLE_FORGOT_PASSWORD_IS_NOT_AVAILABLE:
    "The password recovery process is not available",
  MY_HR_TITLE_UNLOCK: "Your session is locked",
  MY_HR_UNLOCK: "Unlock",
  MY_HR_UNSAVED_ELEMENTS: "There are unsaved elements on this page!",
  MY_HR_USER_ACCOUNT: "User account",
  MY_HR_USER: "User",
  MY_HR_USERNAME: "Username",
  MY_HR_USERS: "Users",
  MY_HR_USING_STRONG_PASSWORD: "Using strong password",
  MY_HR_VIEW_MY_PAYCARD: "I view my paycard",
  MY_HR_ZIP: "Zip code",
  MY_HR_ERROR_MESSAGE_PASSWORD_IS_WRONG:
    "The password is not eligible for the password policy!",
  MY_HR_NOT_LOGGED_IN: "Not logged in yet",
  MY_HR_PASSWORD_CHANGE_SUCCEEDED: "Change password was a success",
  MY_HR_ROLE_CREATED_SUCCESSFULLY: "Role created successfully",
  MY_HR_ROLE_CREATION_FAILED: "Role creation failed!",
  MY_HR_ROLE_REMOVED_SUCCESSFULLY: "Role removed successfully",
  MY_HR_ROLE_REMOVE_FAILED: "Role remove failed!",
  MY_HR_ROLE_UPDATED_SUCCESSFULLY: "Role updated successfully",
  MY_HR_ROLE_UPDATE_FAILED: "Role update failed!",
  MY_HR_ABOUT: "About",
  MY_HR_USER_GUIDES: "User guides",
  MY_HR_USER_GUIDE: "MyHR user guide",
  MY_HR_ADMIN_GUIDE: "MyHR administrator guide",
  MY_HR_ERROR_MESSAGE_EMAIL_IS_EXIST: "This email is already exist!",
  MY_HR_IMPORT_USERS: "Import users",
  MY_HR_IMPORT_USERS_FROM_JDOLBER: "Import users from JDolBer",
  MY_HR_IMPORT_USERS_FROM_SSHR: "Import users from NextGen SSHR",
  MY_HR_IMPORT_USERS_TEXT_INFO:
    "Import new users from the JDolBer Human Management System. The import does not affect current OrgwareConnect users. This process may takes for minutes.",
  MY_HR_IMPORT_SSHR_USERS_TEXT_INFO:
    "Import new users from the NextGen SSHR System. The import does not affect current OrgwareConnect users. This process may takes for minutes.",
  MY_HR_IMPORT_SSHR_USERS_LOCKED_INFO:
    "The import function is not available currently, because another import is running.",
  MY_HR_EMPLOYEE_CODE: "Employee code",
  MY_HR_WORK_EMAIL_IS_MISSING: "Work email is missing!",
  MY_HR_OTHER_USER_ALREADY_HAS_THIS_EMAIL:
    "Other employee already has this email address:",
  MY_HR_IMPORT_HAS_DONE_WITH_ERROR: "Import has done with errors!",
  MY_HR_IMPORT_HAS_DONE: "Import has done successfully!",
  MY_HR_ITEM_PROCESSED: "item processed",
  MY_HR_EMPLOYEE_IMPORTED: "employee imported",
  MY_HR_ERROR_COUNT_ON_IMPORT: "error(s) occured on import",
  MY_HR_INTERRUPT: "Interrupt",
  MY_HR_USER_HAS_NO_CONTRACT: "User has no contract data!",
  MY_HR_USER_HAS_NO_EMPLOYEE_DATA: "User has no employee data!",
  MY_HR_APPLICATIONS: "Applications",
  MY_HR_CLEAR_CACHE: "Clear cache",
  MY_HR_CLEAR_CACHE_TEXT:
    "Clear server side cache. It refreshes all value from JDolBer.",
  MY_HR_CLEAR_CACHE_SUCCEEDED: "Server side cache cleared.",
  MY_HR_DATE_RANGE_ERROR: "The start date must be earlier than the end date!",
  MY_HR_FIVE_MIN_REFRESH:
    "The system will perform an update in 5 minutes, please save your ongoing processes and press the “Update” button!",
  MY_HR_UPDATE_AVAIABLE: "Update is available",
  MY_HR_CONTRACT_OF_SERVICES: "contract of services",
  MY_HR_PROFILE_IMAGE: "Profile image",
  MY_HR_PROFILE_IMAGE_EDIT: "Profile image edit",
  MY_HR_IMAGE_UPLOAD: "Image upload",
  MY_HR_DISTRICT: "District",
  MY_HR_DRAG_AND_DROP: "Drag and drop or browse",
  MY_HR_PROFILE_IMAGE_UPLOAD_SUCCEEDED: "Image uploaded successfully.",
  MY_HR_PROFILE_PROFILE_IMAGE_UPLOAD_FAILED: "Image upload failed.",
  MY_HR_PROFILE_IMAGE_UPLOAD_SIZE_FAILED: "Image is too large.",
  MY_HR_ADD_GROUP_ROLE: "Add role",
  MY_HR_INACTIVATE_GROUP: "Inactivate",
  MY_HR_REMOVE_GROUP_ROLE: "Remove role",
  MY_HR_ADD_GROUP_ROLE_TITLE: "Add group role",
  MY_HR_INACTIVATE_GROUP_TITLE: "Managing users",
  MY_HR_REMOVE_GROUP_ROLE_TITLE: "Remove group role",
  MY_HR_REMOVE: "Remove",
  MY_HR_CLOSE: "Close",
  MY_HR_MERGED: "Merged",
  MY_HR_CONTRACT_DATA_NOT_AVAIABLE: "Contract data not avaiable",
  MY_HR_UPLOAD_FILE: "File upload (optional)",
  MY_HR_ADD_NEW_ADDRESS: "Add new address",
  MY_HR_ADDRESS_INVALIDATION: "Address invalidation",
  MY_HR_EDIT_NAME: "Edit name",
  MY_HR_EDIT_MOTHERS_NAME: "Edit mothers name",
  MY_HR_INVALIDITON: "invalidation",
  MY_HR_DATE_OF_VALIDITY: "Date of validity",
  MY_HR_PREFIXNAME: "Prefix name",
  MY_HR_LASTNAME: "Last name",
  MY_HR_FIRSTNAME: "First name",
  MY_HR_MIDDLENAME: "Middle name",
  MY_HR_NAMESUFFIX: "Suffix name",
  MY_HR_COUNTRYOFBIRTH: "Country of birth",
  MY_HR_PLACEOFBIRTH: "Place of birth",
  MY_HR_MOTHERSNAME: "Mother name",
  MY_HR_MARITALSTATUS: "Marital status",
  MY_HR_TAXNUMBER: "Tax Number",
  MY_HR_DATEOFBIRTH: "Date Of birth",
  MY_HR_SOCIALSECURITYNUMBER: "Social security number",
  MY_HR_IDENTITYCARDNUMBER: "Identity card number",
  MY_HR_WORKEMAIL: "Work email",
  MY_HR_OTHEREMAIL: "Other email",
  MY_HR_STREETNAME: "Street",
  MY_HR_STREETTYPE: "Street type",
  MY_HR_STREETNUMBER: "Street number",
  MY_HR_BUILDING: "Building",
  MY_HR_STAIRWAY: "Stairway",
  MY_HR_FLOOR: "Floor",
  MY_HR_DOOR: "Door",
  MY_HR_MESSAGE: "message",
  MY_HR_ATTACHMENTS: "Attachments",
  MY_HR_ATTACHMENT: "attachment",
  MY_HR_MOTHERSPREFIXNAME: "Prefix name",
  MY_HR_MOTHERSLASTNAME: "Last name",
  MY_HR_MOTHERSFIRSTNAME: "First name",
  MY_HR_MOTHERSFIRSTNAME2: "Middle name",
  MY_HR_MOTHERSNAMESUFFIX: "Suffix name",
  MY_HR_WORKPHONE: "Work phone",
  MY_HR_WORKMOBILEPHONE: "Work mobile",
  MY_HR_PRIVATEPHONE: "Private mobil",
  MY_HR_CHANGE_REQUEST_SUCCEEDED: "Change request successfully approved",
  MY_HR_CHANGE_REQUEST_REJECTED: "Change request successfully rejected",
  MY_HR_HELPDESK_CONTACTS: "System administrator contacts",
  MY_HR_HELPDESK_CONTACTS_INFO:
    "In case of problems, please contact your local system administrator.",
  MY_HR_PHONE: "Phone",
  MY_HR_HELPDESK_URL: "Helpdesk URL",
  MY_HR_HELPDESK_CUSTOM_INFO_TEXT: "Specifying a unique information text",
  MY_HR_CUSTOM_TEXT: "Custom text",
  MY_HR_EDIT_DATE_OF_BIRTH: "Edit date of birth",
  MY_HR_EDIT_COUNTRY_OF_BIRTH: "Edit country of birth",
  MY_HR_EDIT_PLACE_OF_BIRTH: "Edit place of birth",
  MY_HR_EDIT_GENDER: "Edit gender",
  MY_HR_EDIT_MARITAL_STATUS: "Edit marital status",
  MY_HR_EDIT_TAX_NUMBER: "Edit marital status",
  MY_HR_EDIT_SOCIAL_SECURITY_NUMBER: "Edit social security number",
  MY_HR_EDIT_IDENTITY_CARD_NUMBER: "Edit identity card number",
  MY_HR_EDIT_NATIONALITY: "Edit nationality",
  MY_HR_CHANGE_REQUEST_SETTINGS_INFO:
    "The employee can announce a change in theie personal or contact information.",
  MY_HR_DELETE_REQUEST: "The request was successfully deleted",
  MY_HR_DELETE_REQUEST_ERROR: "The request could not be deleted",
  MY_HR_EXAMINER_USER_GUIDE: "MyHR examiner user manual",
  MY_HR_NOT_SAME_PASSWORD:
    "The new password cannot be the same as the current password!",
  MY_HR_ESCAPE_TEXT: "Are you not %fullname%?",
  MY_HR_CHANGE_PASSWORD: "Change password",
  MY_HR_LOCKUP: "Lockup",
  MY_HR_REMOVE_ROLE_ERROR: "Removing the role failed with errors!",
  MY_HR_BANK_ACCOUNT: "Bank account number",
  MY_HR_BANK_ACCOUNTS: "Bank account numbers",
  MY_HR_DELETE_CHANGE_REQUEST_TEXT: "Are you sure you want to delete the request?",
  MY_HR_REJECTED_CHANGE_REQUEST: "Change request rejected",
  MY_HR_REJECTED_CHANGE_REQUEST_TEXT: "Are you sure you want to reject the request?",
  MY_HR_DIRECTORY: "Directory sign-in",
  OC_MONDAY: "Monday",
  OC_TUESDAY: "Tuesday",
  OC_WEDNESDAY: "Wednesday",
  OC_THURSDAY: "Thursday",
  OC_FRIDAY: "Friday",
  OC_SATURDAY: "Saturday",
  OC_SUNDAY: "Sunday",
};
